<template>
  <div>
    <v-toolbar class="mb-3" light app v-if="isUserLoggedIn">
      <img v-if="!$vuetify.breakpoint.xs" style="max-height:50px" :src="$store.state.userOrg.logo" alt="">
      <v-avatar v-if="$vuetify.breakpoint.xs">
        <img  :src="$store.state.userOrg.icon" alt="">
      </v-avatar>
      <!-- <v-menu offset-y v-if="$vuetify.breakpoint.xs">
      <template v-slot:activator="{ on }">
        <v-btn
          color="grey"
          dark
          v-on="on"
          flat
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="item in navbarList.filter(x=>!x.group)" :key="item.title" :to="item.route" @click="setCurrentRoute(item.route)">
                <v-list-tile-action>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content wrap>
                  <v-list-tile-subtitle wrap>
                    <b>{{item.title}}</b>
                  </v-list-tile-subtitle>
                </v-list-tile-content>
              </v-list-tile>
      </v-list>
    </v-menu> -->
      
      
      
      <!-- <v-toolbar-title class="text-uppercase grey--text" v-if="mini"></v-toolbar-title> -->
      <v-spacer></v-spacer>

      <v-list-tile xs6 sm3 md3 lg3>

        <v-list-tile-content class="hidden-sm-and-down">
          <v-list-tile-title class="font-weight-bold">{{user.name}} {{user.surname}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-tooltip bottom class="mx-2">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" style="cursor: pointer" @click="logout()">exit_to_app</v-icon>
        </template>
        <span>Logout</span>
      </v-tooltip>
    </v-toolbar>
   
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ACCOUNT DETAILS</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Personal Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="user.name" label="*First Name" persistent-hint required></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="user.surname" label="*Surname" persistent-hint required></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="user.idNumber"
                  label="*RSA ID Number or Passport Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Contact Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="user.mobileNumber" label="*Mobile Number" persistent-hint></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="user.telephoneNumber"
                  label="Telephone Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Login Settings</h3>
              </v-flex>

              <v-flex xs12 sm3 md6>
                <v-text-field
                  v-model="user.emailAddress"
                  prepend-icon="email"
                  label="*Email Address"
                  persistent-hint
                  type="email"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="password" prepend-icon="security" label="Reset Password"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-btn flat color="primary" @click="resetPassword">Reset</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="dialog=false">Cancel</v-btn>
          <v-btn color="primary" round @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <nav width="7500px" v-if="!$vuetify.breakpoint.xs">
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="mini"
        hide-overlay
        stateless
        dark
        app
        width="315px"
      >
      <v-toolbar height="70px" flat class="transparent text-md-center">
         <v-list class="pa-0" v-if="!mini">
                  <v-list-tile v-on="on">
                    <v-avatar class="white">
                      <v-img
                        contain
                        alt="Avatar"
                        v-if="$store.state.userOrg"
                        :key="$store.state.userOrg.logo"
                        :src="$store.state.userOrg.icon?$store.state.userOrg.icon:$store.state.userOrg.logo"
                      />
                    </v-avatar>
                    <v-toolbar-title class="navbarTextColour--text" v-show="!mini">
                      <span
                        v-resize-text
                        class="font-weight-light mr-3"
                        wrap
                      >{{$store.state.userOrg.name}}</span>
                    </v-toolbar-title>
                    <v-list-tile-action>
                  <v-btn icon @click.stop="mini = !mini">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                </v-list-tile-action>
                  </v-list-tile>
                </v-list>
             <v-avatar class="ma-0 pa-0 white" v-else @click="mini=!mini">
                      <v-img
                        contain
                        alt="Avatar"
                        v-if="$store.state.userOrg"
                        :key="$store.state.userOrg.logo"
                        :src="$store.state.userOrg.icon?$store.state.userOrg.icon:$store.state.userOrg.logo"
                      />
                    </v-avatar>
          </v-toolbar>
        <v-layout column align-Left>
          <v-divider></v-divider>
          
          <v-list>
              <v-list-tile v-for="item in navbarList.filter(x=>!x.group)" :key="item.title" :to="item.route" @click="setCurrentRoute(item.route)">
                <v-list-tile-action>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content wrap>
                  <v-list-tile-subtitle wrap>
                    <b>{{item.title}}</b>
                  </v-list-tile-subtitle>
                </v-list-tile-content>
              </v-list-tile>
            <v-list-group
              wrap
              class="font-weight-thin body-2 navbarTextColour--text"
              v-for="item in navbarList.filter(x=>x.group)"
              :key="item.title"
              :id="item.id"
              :prepend-icon="item.icon"
              no-action
              v-model="item.active"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content wrap>
                    <v-list-tile-subtitle wrap>
                      <b>{{ item.title }}</b>
                    </v-list-tile-subtitle>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                v-for="subItem in item.items"
                :key="subItem.title"
                :id="subItem.id"
                router
                :to="subItem.route"
                @click="setCurrentRoute(subItem.route)"
              >
                <v-list-tile-content wrap>
                  <v-divider color="white"></v-divider>
                  <v-list-tile-subtitle>{{ subItem.title }}</v-list-tile-subtitle>
                  <v-divider color="grey"></v-divider>
                </v-list-tile-content>
                <v-list-tile-action></v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-layout>
      </v-navigation-drawer>
    </nav> -->

  </div>
</template>

<script >
import { mapState } from "vuex";
import Api from "@/services/Api";
import Push from "push.js";
import configData from "../../../config/config.json";
import dateformat from "dateformat";
export default {
  props: ["primaryColour"],
  watch: {
    "$vuetify.breakpoint.xs": {
      immediate: true,
      handler(value) {
        if (value) {
          this.mini = true;
        }
      },
    },
  
"$vuetify.breakpoint.sm": {
      immediate: true,
      handler(value) {
        if (value) {
          this.mini = true;
        }
      },
    },
  },
  methods: {
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy HH:MM");
      } else {
        null;
      }
    },
 
    saveCustomer() {
      Api()
        .put("/ispsettings/" + this.customer.ispSettings[0].id, {
          regNo: this.customer.ispSettings[0].regNo,
          vatNo: this.customer.ispSettings[0].vatNo,
          ispTermsConditionsLink: this.customer.ispSettings[0]
            .ispTermsConditionsLink,
          fupUrl: this.customer.ispSettings[0].fupUrl,
          applicationsEmailAddress: this.customer.ispSettings[0]
            .applicationsEmailAddress,
          bankName: this.customer.ispSettings[0].bankName,
          bankBranchCode: this.customer.ispSettings[0].bankBranchCode,
          bankAccountType: this.customer.ispSettings[0].bankAccountType,
          bankAccountNumber: this.customer.ispSettings[0].bankAccountNumber,
        })
        .then((response) => {
          this.getCustomer(this.$store.state.customerId);
          this.customerDialog = false;
        });
    },
    save() {
      Api().put("/contacts/" + this.user.id, {
        name: this.user.name,
        surname: this.user.surname,
        idNumber: this.user.idNumber,
        mobileNumber: this.user.mobileNumber,
        telephoneNumber: this.user.telephoneNumber,
        permissions: this.user.permissions,
        emailAddress: this.user.emailAddress,
        isActive: this.user.isActive,
      });
      this.dialog = false;
    },
    resetPassword() {
      Api()
        .put("/contacts/resetPassword/" + this.user.id, {
          name: this.user.name,
          surname: this.user.surname,
          idNumber: this.user.idNumber,
          mobileNumber: this.user.mobileNumber,
          password: this.password,
          Password: this.password,
          telephoneNumber: this.user.telephoneNumber,
          permissions: this.user.permissions,
          emailAddress: this.user.emailAddress,
          isActive: this.user.isActive,
        })
        .then((response) => {
          this.text = "Password Successfully Reset!";
          this.snackbar = true;
          this.$emit("contacts");
        });
      this.password = "";
      this.dialog = false;
    },
    checkLogin() {
      this.permission = this.$store.state.permission;
      if (this.$store.state.isUserLoggedIn === true) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
    isEven(n) {
      return n % 2 == 0;
    },
    logout() {
      this.showISPNav = false;
      this.showFNONav = false;
      this.drawer = false;
      this.loggedIn = false;
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setIsUserLoggedIn", false);
      this.$store.dispatch("setCurrentOrg", null);
      this.$store.dispatch("setOrgToken", null);
      this.$store.dispatch("setCurrentRoute", null);
      this.$store.dispatch("setOrganisations", null);
      this.$router.push("/userPortal/login");
      this.isUserLoggedIn = false;
    },
    async getCustomer(customerId) {
      await Api()
        .get("/customers/" + customerId)
        .then((response) => {
          this.customer = response.data[0];
        });
    },
    async setCurrentRoute(item) {
      await this.$store.dispatch("setCurrentRoute", item);
    },

  },
  async created() {
    this.config = configData;
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"]),
  },
  data() {
    return {
      playerId: null,
      isLoading: false,
      contactTypes: [],
      search: "",
      select: null,
      searchResults: [],
      password: "",
      drawer: true,
      dialog: false,
      customer: [],
      loggedIn: false,
      showFNONav: false,
      showISPNav: false,
      permission: "",
      key: 0,

      navbarList: [
         {
          icon: "dashboard",
          title: "Dashboard",
          route: "/userPortal/dashboard",
        },
      
        // Operations   /////////////////////////////////////////////////////////////////////////////////////
        {
          icon: "build",
          title: "Services",
          route: "/userPortal/services"
        },
        {
          icon: "gamepad",
          title: "Orders",
          route: "/userPortal/orders" 
        },
      ],
      mini: false,
      miniIsp: false,
      right: null,
      snackbar: false,
      customerDialog: false,
      allRoutes: [],
    };
  },
};
</script>